/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-plus-filled\":\"Sirkel med plusstegn i\"}");